import Vue from 'vue'

export default {
  getRepositories ({ commit }) {
    return Vue.api.get('engine/repositories')
      .then((res) => commit('init', { repositories: res.data }))
  },
  getGithubRepositories (ctx, data) {
    const sync = data.sync ? 'sync=true' : ''
    return Vue.api.get('engine/repositories/github/' + (data.applicationId || '') + '?' + sync)
      .then((res) => {
        if (res.status === 201) {
          window.location.href = res.data.toString()
          return Promise.reject(new Error())
        } else {
          return res.data
        }
      })
  },
  getRepositoryApplications ({ commit }, data) {
    return Vue.api.get('engine/repositories/' + data.id).then((res) => res.data.applications)
  },
  createRepository ({ commit }, data) {
    return Vue.api.post('engine/repositories', data)
      .then((res) => {
        commit('repository', res.data)
        return res.data
      })
  },
  createGithubRepository ({ commit }, data) {
    return Vue.api.post('engine/repositories/github', data)
      .then((res) => commit('repository', res.data))
  },
  connectRepository ({ commit }, data) {
    return Vue.api.put('engine/repositories/' + data.id + '/' + data.applicationId, data)
  },
  unlinkRepository ({ commit }, data) {
    return Vue.api.delete('engine/repositories/' + data.id + '/' + data.applicationId)
  },
  removeRepository ({ commit }, data) {
    return Vue.api.delete('engine/repositories/' + data.id)
  }
}
